import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, object=logged in, false=not logged in
  const [error, setError] = useState("");

  useEffect(() => {
    let ignore = false;
    api.get("/auth/me")
      .then((r) => { if (!ignore) setUser(r.data); })
      .catch(() => { if (!ignore) setUser(false); });
    return () => { ignore = true; };
  }, []);

  async function login(email, password) {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  }

  async function register(payload) {
    setError("");
    try {
      const { data } = await api.post("/auth/register", payload);
      setUser(data);
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  }

  async function refreshUser() {
    try { const r = await api.get("/auth/me"); setUser(r.data); return r.data; } catch { return null; }
  }

  return (
    <AuthContext.Provider value={{ user, error, login, register, logout, refreshUser, setError }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
